export default {
    API_KEY: "FIREBASE_API_KEY",
};
